import React from 'react'

import { shallowEqual, useSelector } from 'react-redux'

import { getThumbnailIcon } from '@components/Submission/Card/Thumbnail/Thumbnail'
import { IApplicationState } from '@store/index'
import { selectSocialSubmissionType, selectSubmission } from '@store/submissions'
import Theme from '@theme'
import { Container, Icon } from '@tribegroup'
import { getSubmissionFlags } from '@utils/getSubmissionFlags'

interface IProps {
  submissionId: number
  color?: string
}

export const OverlayIcon: React.FC<IProps> = ({ submissionId, color = Theme.whiteColor }) => {
  const { submission, socialSubmissionType } = useSelector((state: IApplicationState) => {
    return {
      submission: selectSubmission(state, submissionId),
      socialSubmissionType: selectSocialSubmissionType(state, submissionId),
    }
  }, shallowEqual)
  // getSubmissionFlags builds a fresh object; compute it outside useSelector so it
  // never becomes the selector's return value (which would loop under react-redux 9).
  const flags = getSubmissionFlags(submission)
  const glyphIcon = getThumbnailIcon(flags, socialSubmissionType)
  if (glyphIcon) {
    return (
      <Container absolute bottomPosition={0.5} leftPosition={1}>
        <Icon
          shadowed
          size={1.5}
          glyph={glyphIcon}
          opacity={0.9}
          color={color}
          data-testid="submission-glyph-icon"
        />
      </Container>
    )
  }
  return null
}

export default OverlayIcon
